import z from "zod";

export const optionalNumberString = (message = "Ongeldig getal") =>
    z
        .string()
        .trim()
        .optional()
        .refine((val) => !val || (!isNaN(Number(val)) && Number(val) >= 0), {
            message,
        });

export const requiredNumberString = (requiredMessage = "Dit veld is verplicht", invalidNumberMessage = "Ongeldig getal") =>
    z
        .string()
        .trim()
        .nonempty(requiredMessage)
        .refine((val) => !isNaN(Number(val)) && Number(val) >= 0, {
            message: invalidNumberMessage,
        });

/**
 * Normalizes optional RHF text input.
 * Useful when the value should start as "" rather than undefined to satisfy RHF recommendations and avoid uncontrolled-to-controlled warnings.
 * Converts "" to undefined, then trims.
 */
export const optionalFormString = () => z.preprocess((value) => (value === "" ? undefined : value), z.string().trim().optional());

/**
 * Normalizes optional RHF select/enum input.
 * Use when a controlled form field may produce "" or null for "no value" when needing to satisfy RHF recommendations and avoid uncontrolled-to-controlled warnings.
 * Converts "" and null to undefined before enum validation.
 */
export const optionalFormEnum = <T extends readonly [string, ...string[]]>(values: T) =>
    z.preprocess((value) => (value === "" || value === null ? undefined : value), z.enum(values).optional());
